<template>
  <component :is="el" :prop="prop" :required="required">
    <template #label><span><i v-if="icon" :class="icon">&nbsp;</i><template v-for="(line, i) in labelLines"><br v-if="i" :key="i" />{{line}}</template></span></template>

    <span v-if="noForm"><i v-if="icon" :class="icon">&nbsp;</i><template v-for="(line, i) in labelLines"><br v-if="i" :key="i" />{{line}}</template></span>

    <el-checkbox
      v-model="form"
      :disabled="disabled"
      @change="updated">
      <slot></slot>
    </el-checkbox><!-- XOL-596: optional trailing slot INSIDE the form item (the request drawer's "changed underneath you" cue); nothing renders when unused. No whitespace before it, so the unused markup is unchanged. --><slot name="cue"></slot>

  </component>

</template>

<script>

export default {
  name: 'check-box',

  props: {

    label: {
      type: String,
      default: null
    },

    name: {
      type: String
    },

    value: {
//      type: Boolean,
      required: true
    },

    disabled: {
      type: Boolean,
      default: false
    },

    required: {
      type: Boolean,
      default: false
    },

    icon: {
      type: String,
      default: null
    },

    helpText: {
      type: String,
      default: null
    },

    prop: {
      type: String,
      default: null
    },

    noForm: {
      type: Boolean,
      default: false
    }

  },



  computed: {
    // Split the label on newlines so callers can render a multi-line label
    // (rendered with <br> in the template). Single-line labels are unaffected.
    labelLines () {
      return (this.label == null ? '' : String(this.label)).split('\n')
    }
  },



  methods: {

    updated (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }

  },

  watch: {
    value: function (val) {
      this.form = val
    }
  },


  data () {
    return {
      form: this.value,
      el: this.noForm ? 'div' : 'el-form-item'
    }
  }
}
</script>
